import styled from 'styled-components';

const Container = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${({ withoutPadding }) => (withoutPadding ? 0 : '12px 12px 0 24px')};
  row-gap: 10px;
  flex-wrap: wrap;
  min-width: 676px;
`;

export default Container;
